import Checkbox from "./checkbox";

const ListItemDisplay = ({ isSelected, onSelectedChange, children }) => (
  <div
    className="d-flex align-items-center mb-2 p-2 border rounded-lg"
    style={{ backgroundColor: isSelected ? "#f0f0f0" : "white", fontSize: "16px" }}
  >
    <Checkbox size={"large"} isChecked={isSelected} onChange={onSelectedChange} />
    { children }
  </div>
)

export default ListItemDisplay;
